// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICustomPageable } from './ICustomPageable';
import {
    ICustomPageableFromJSON,
    ICustomPageableFromJSONTyped,
    ICustomPageableToJSON,
    ICustomPageableToJSONTyped,
} from './ICustomPageable';
import type { IOrganizationShortDto } from './IOrganizationShortDto';
import {
    IOrganizationShortDtoFromJSON,
    IOrganizationShortDtoFromJSONTyped,
    IOrganizationShortDtoToJSON,
    IOrganizationShortDtoToJSONTyped,
} from './IOrganizationShortDto';

/**
 * 
 * @export
 * @interface ICustomPageOrganizationShortDto
 */
export interface ICustomPageOrganizationShortDto {
    /**
     * 
     * @type {number}
     * @memberof ICustomPageOrganizationShortDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageOrganizationShortDto
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageOrganizationShortDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageOrganizationShortDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageOrganizationShortDto
     */
    empty?: boolean;
    /**
     * 
     * @type {Array<IOrganizationShortDto>}
     * @memberof ICustomPageOrganizationShortDto
     */
    content?: Array<IOrganizationShortDto>;
    /**
     * 
     * @type {ICustomPageable}
     * @memberof ICustomPageOrganizationShortDto
     */
    pageable?: ICustomPageable;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageOrganizationShortDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageOrganizationShortDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageOrganizationShortDto
     */
    total_elements?: number;
}

/**
 * Check if a given object implements the ICustomPageOrganizationShortDto interface.
 */
export function instanceOfICustomPageOrganizationShortDto(value: object): value is ICustomPageOrganizationShortDto {
    return true;
}

export function ICustomPageOrganizationShortDtoFromJSON(json: any): ICustomPageOrganizationShortDto {
    return ICustomPageOrganizationShortDtoFromJSONTyped(json, false);
}

export function ICustomPageOrganizationShortDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICustomPageOrganizationShortDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'size': json['size'] == null ? undefined : json['size'],
        'last': json['last'] == null ? undefined : json['last'],
        'first': json['first'] == null ? undefined : json['first'],
        'empty': json['empty'] == null ? undefined : json['empty'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IOrganizationShortDtoFromJSON)),
        'pageable': json['pageable'] == null ? undefined : ICustomPageableFromJSON(json['pageable']),
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}

export function ICustomPageOrganizationShortDtoToJSON(json: any): ICustomPageOrganizationShortDto {
    return ICustomPageOrganizationShortDtoToJSONTyped(json, false);
}

export function ICustomPageOrganizationShortDtoToJSONTyped(value?: ICustomPageOrganizationShortDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'last': value['last'],
        'first': value['first'],
        'empty': value['empty'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IOrganizationShortDtoToJSON)),
        'pageable': ICustomPageableToJSON(value['pageable']),
        'totalPages': value['total_pages'],
        'numberOfElements': value['number_of_elements'],
        'totalElements': value['total_elements'],
    };
}

